import { AxiosError } from 'axios'
import { validationMessage } from '@/shared/api/errorHandling'
import { CHAT_COPY } from './chatCopy'

export function chatStatus(error: unknown): number | null {
  return error instanceof AxiosError ? (error.response?.status ?? null) : null
}

export function isChatAccessRevoked(error: unknown): boolean {
  const status = chatStatus(error)
  return status === 401 || status === 403
}

export function chatErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof AxiosError)) return fallback

  const response = error.response
  if (!response) return CHAT_COPY.transportFailed

  const data = response.data as unknown

  const fromArray = validationMessage(data)
  if (fromArray) return fromArray

  if (data && typeof data === 'object' && typeof (data as { message?: unknown }).message === 'string') {
    return (data as { message: string }).message
  }

  if (response.status === 403 || response.status === 401) return CHAT_COPY.accessEnded
  if (response.status === 404) return CHAT_COPY.notAvailable

  return fallback
}
